import React from "react";
import { QuoteOneLine } from "@/.storyblok/types/319751/storyblok-components";
import { SbBlokData, storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import Link from "next/link";

interface QuoteOneLineProps {
  blok?: QuoteOneLine & SbBlokData;
}

const QuoteOneLineComponent: React.FC<QuoteOneLineProps> = ({ blok }) => {
  if (!blok) return null;

  const { quote, logo, name, position, company, company_link } = blok;

  return (
    <div className="container mb-4 mb-lg-5">
      <div {...storyblokEditable(blok)} className="full-width">
        <div className="testimonial-container">
          <div className="testimonial">
            {logo?.filename && company_link?.url && (
              <Link
                href={company_link.url}
                target={company_link.target || "_blank"}
                className="testimonial-image"
              >
                <Image
                  src={logo.filename}
                  alt={logo.alt || `${company} Logo`}
                  title={logo.title || `${company} Logo`}
                  width={180}
                  height={106}
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  loading="lazy"
                  quality={75}
                />
              </Link>
            )}
            <div className="testimonial-content">
              {quote && <p>{quote}</p>}
              <hr />
              {(name || position || company) && (
                <div className="testimonial-summary">
                  <p>
                    {name}
                    {(position || company) && (
                      <span>
                        &nbsp;
                        {position && `${position}, `}
                        {company_link?.url ? (
                          <Link
                            href={company_link.url}
                            target={company_link.target || "_blank"}
                            rel="noopener"
                            className="text-decoration-none"
                          >
                            {company}
                          </Link>
                        ) : (
                          company
                        )}
                      </span>
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteOneLineComponent;